<template>
    <gmap-map
        :center="center"
        :zoom="currentZoom"
        :options="mapOptions"
        >
        <gmap-marker
            :position="center"
            :clickable="true"
            :draggable="true"
            ></gmap-marker>
    </gmap-map>
</template>
<script>
import GMaps from 'gmaps';

const defaultMarker = {
    zoom: 16,
    position: { lat: -37.1986694, lng: 174.9056512 },
};

export default {
    name: "MapMarkerComponent",

    data() {
        const location = _.get(this.initialData, 'position');
        const zoom = _.get(this.initialData, 'zoom');
        return {
            center: location,
            currentZoom: zoom || 16,
            mapOptions: {
                disableDefaultUI: true,
                mapTypeControl: false,
                scaleControl: true,
                zoomControl: true,
                fullscreenControl: true,
            }
        };
    },

    props: ['initialData', 'config'],
}
</script>



// WEBPACK FOOTER //
// resources/assets/site/js/components/GmapComponent.vue